














































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GasyaResultUnit } from "@/constants";

@Component
export default class AwaikenUnitTextComponent extends Vue {
  @Prop() unit!: GasyaResultUnit;
  @Prop() awaikingNum!: number;
  animeIdx = 0;
  timeoutID = -1;
  readonly w = 792;
  readonly h = 792 * 1.5;
  readonly numH = 100;
  readonly mesH = 50;
  readonly lastAnimeIdx = 3;
  mounted() {
    this.timeoutID = setTimeout(this.next, 200);
  }
  @Watch("unit")
  changeUnit() {
    this.animeIdx = 0;
    this.timeoutID = setTimeout(this.next, 200);
  }
  next() {
    clearTimeout(this.timeoutID);
    this.animeIdx++;
    if (this.animeIdx <= this.lastAnimeIdx) {
      this.timeoutID = setTimeout(this.next, 200);
    }
  }
  click() {
    if (this.animeIdx <= this.lastAnimeIdx) {
      this.next();
    } else {
      this.$emit("done");
    }
  }
}
